import EmbeddedVideo from './EmbeddedVideo'
import Quill from 'quill'
import generateEmbedUrl from './parser'

Quill.register(EmbeddedVideo, true)

export default function VideoEmbed (quill) {
	function listenAndInsertVideo (newDelta, oldDelta, from) {
		if (from !== 'user') return

		const lastOperation = newDelta.ops[newDelta.ops.length - 1]
		if (!lastOperation.insert || !/\n$/.test(lastOperation.insert)) return

		const currentPosition = quill.getSelection(true).index
		const lineIndex = currentPosition - 1
		const [lineBlot, lineOffset] = quill.getLine(lineIndex)
		const currentLineText = quill.getText(lineIndex - lineOffset, lineOffset)
		const lineStartIndex = quill.getIndex(lineBlot)

		const embed = generateEmbedUrl(currentLineText)

		if (embed) {
			quill.deleteText(lineStartIndex, currentLineText.length)
			quill.insertEmbed(lineStartIndex, 'embeddedvideo', embed, 'api')
		}
	}
	quill.on('text-change', listenAndInsertVideo)
}
